/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSize } from '../../factoriesNumber.js';
export var sizeDependencies = {
  typedDependencies,
  createSize
};